import React from 'react';
import styles from './TabBar.module.scss';
import classNames from 'classnames';

export const tabBarVariants = {
  full: 'full',
  pill: 'pill',
  underline: 'underline',
};
export const TabBarComponent = ({ tabs, activeTab, onTabClick, variant }) => {
  const handleTabClick = (tab) => {
    if (activeTab === tab) return;
    onTabClick?.(tab);
  };
  return (
    <div
      className={classNames(styles.tabBar, {
        [styles.tabBar_pill]: variant === tabBarVariants.pill,
        [styles.tabBar_underline]: variant === tabBarVariants.underline,
      })}
    >
      {tabs?.map((tab, index) => {
        const isActive = activeTab === tab?.value;
        return (
          <div
            key={index}
            className={classNames(styles.tab, {
              [styles.tab_active]: isActive,
              [styles.tab_full]: variant === tabBarVariants.full,
              [styles.tab_active_full]:
                variant === tabBarVariants.full && isActive,
              [styles.tab_pill]: variant === tabBarVariants.pill,
              [styles.tab_active_pill]:
                variant === tabBarVariants.pill && isActive,
              [styles.tab_underline]: variant === tabBarVariants.underline,
              [styles.tab_active_underline]:
                variant === tabBarVariants.underline && isActive,
            })}
            onClick={() => handleTabClick(tab?.value)}
          >
            {tab?.icon}
            {tab?.label}
            {tab?.count != null && (
              <span className={styles.tabCount}>{tab.count}</span>
            )}
          </div>
        );
      })}
    </div>
  );
};
